export default __webpack_public_path__ + "static/media/nut-comic-3.e2218197.png";